
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16">
          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-semibold mb-4 md:text-3xl md:mb-8">{t('navigation')}</h4>
            
            {/* Desktop Links - Only visible on desktop */}
            <ul className="space-y-2 hidden md:block md:space-y-6">
              <li>
                <a href="/" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base md:text-xl">
                  {t('home')}
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base md:text-xl">
                  {t('about')}
                </a>
              </li>
              <li>
                <a href="/project/wildcherry" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base md:text-xl">
                  Wild Cherry
                </a>
              </li>
              <li>
                <a href="/project/leveaudor" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base md:text-xl">
                  Le Veau d'Or
                </a>
              </li>
              <li>
                <a href="/project/lerock" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base md:text-xl">
                  Le Rock
                </a>
              </li>
              <li>
                <a href="/project/frenchette" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base md:text-xl">
                  Frenchette
                </a>
              </li>
            </ul>
            
            {/* Mobile All Links - Only visible on mobile */}
            <ul className="space-y-2 md:hidden">
              <li>
                <a href="/" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base">
                  {t('home')}
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base">
                  {t('about')}
                </a>
              </li>
              <li>
                <a href="/project/wildcherry" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base">
                  Wild Cherry
                </a>
              </li>
              <li>
                <a href="/project/leveaudor" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base">
                  Le Veau d'Or
                </a>
              </li>
              <li>
                <a href="/project/lerock" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base">
                  Le Rock
                </a>
              </li>
              <li>
                <a href="/project/frenchette" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer text-base">
                  Frenchette
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-semibold mb-4 md:text-3xl md:mb-8">{t('contactInfo')}</h4>
            <div className="space-y-3 md:space-y-8">
              <div className="flex items-center space-x-3 md:space-x-6">
                <i className="ri-mail-line w-6 h-6 flex items-center justify-center text-teal-400 md:w-12 md:h-12"></i>
                <a 
                  href="mailto:davagraphiste@gmail.com"
                  className="text-gray-400 hover:text-teal-400 transition-colors duration-200 cursor-pointer text-base md:text-xl"
                >
                  davagraphiste@gmail.com
                </a>
              </div>
              <div className="flex items-center space-x-3 md:space-x-6">
                <i className="ri-map-pin-line w-6 h-6 flex items-center justify-center text-teal-400 md:w-12 md:h-12"></i>
                <span className="text-gray-400 text-base md:text-xl">New York, NY • Montréal, Québec</span>
              </div>
            </div>
            
            {/* Social Links */}
            <div className="flex items-center space-x-4 mt-6 md:mt-12 md:space-x-8">
              <a href="https://instagram.com/davagraphiste" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors duration-200 cursor-pointer">
                <i className="ri-instagram-line w-8 h-8 flex items-center justify-center md:w-14 md:h-14"></i>
              </a>
              <a href="https://instagram.com/davagraphiste" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors duration-200 cursor-pointer text-base md:text-xl">
                instagram.com/davagraphiste
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center md:mt-16 md:pt-12">
          <p className="text-gray-400 text-base md:text-xl">
            © davagraphiste 2025. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
